import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/breedlogic-frontend-api/breedlogic-frontend-api/breedlogic-web/src/components/registry/RegistryLandingSection.tsx");
